export const HeadingWithDropdownConfig = [
    {
        span: 9,
        height: "45px",
        classes: "marginTop-8",
        columns: [
            {
                span: 8,
                height: "45px",
                rows: [
                    {
                        span: 8,
                        height: "45px",
                    },
                ],
            },
        ],
    },
]
